import * as React from "react";
import {
  getAddressEAN,
  getCompanyName,
  getContractStartDate,
  getEAN,
  getVatNumber,
} from "../../../../../../../scripts/data_format_utils";
import { useSiteData } from "../../../../../../../hooks/use_site";
import { Divider, IconButton, Stack, Typography } from "@mui/material";
import { CollapsableCard } from "../../../../../../../components/general/collapsable_card";

export function InfoLine({ name, value, buttonIcon, onButtonClick, width, minWidth }) {
  return (
    <Stack direction="row" alignItems="center" sx={{ width: width ? width : "100%", pl: "10px" }}>
      <Typography
        variant="body2"
        sx={{
          paddingTop: 1,
          paddingBottom: 1,
          minWidth: minWidth || "300px",
          display: "flex",
          userSelect: "none",
          fontWeight: "bold",
          textTransform: "Uppercase",
          color: "#999",
        }}
      >
        {name}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          wordWrap: "break-word",
          paddingTop: 1,
          paddingBottom: 1,
          fontWeight: "bold",
          display: "inline-block",
          flexGrow: 1,
        }}
      >
        {value ? value : "N/A"}
      </Typography>
      {buttonIcon ? (
        <IconButton sx={{ padding: 0, width: "30px", height: "30px" }} onClick={onButtonClick}>
          {buttonIcon}
        </IconButton>
      ) : null}
    </Stack>
  );
}

export default function CommissioningVerificationGeneralData({
  commissioningCreatedDate,
  commissioningControlStartDate,
  commissioningControlEndDate,
  commissioned_device_names,
  ...props
}) {
  const { data: siteData } = useSiteData();

  const companyName_offtake = getCompanyName(siteData, "offtake");
  const vatNumber_offtake = getVatNumber(siteData, "offtake");
  const ean_offtake = getEAN(siteData, "offtake");
  const addressEan_offtake = getAddressEAN(siteData, "offtake");
  const startDate_offtake = getContractStartDate(siteData, "offtake");
  const companyName_injection = getCompanyName(siteData, "injection");
  const vatNumber_injection = getVatNumber(siteData, "injection");
  const ean_injection = getEAN(siteData, "injection");
  const addressEan_injection = getAddressEAN(siteData, "injection");
  const startDate_injection = getContractStartDate(siteData, "injection");

  return (
    <CollapsableCard startCollapsed={false} title={"General data"} {...props}>
      <Stack direction="column" mx={1} mt={1} mb={1}>
        <Typography variant="h6" color="text.primary_bold">
          Commissioning
        </Typography>
        <Divider />
        <InfoLine
          key={"commissioningCreatedDate"}
          name={"Procedure start date"}
          value={commissioningCreatedDate.toLocaleString()}
        />
        <InfoLine
          key={"commissioningControlStartDate"}
          name={"Device control phase start date"}
          value={commissioningControlStartDate.toLocaleString()}
        />
        <InfoLine
          key={"commissioningControlEndDate"}
          name={"Device control phase end date"}
          value={commissioningControlEndDate.toLocaleString()}
        />
        <InfoLine key={"CommissionedDevices"} name={"Commissioned devices"} value={commissioned_device_names} />

        <Typography variant="h6" color="text.primary_bold">
          Offtake
        </Typography>
        <Divider />
        <InfoLine key={"companyName_offtake"} name={"company"} value={companyName_offtake} />
        <InfoLine key={"vatNumber_offtake"} name={"vat n°"} value={vatNumber_offtake} />
        <InfoLine key={"ean_offtake"} name={"ean"} value={ean_offtake} />
        <InfoLine key={"addressEan_offtake"} name={"address"} value={addressEan_offtake} />
        <InfoLine key={"startDate_offtake"} name={"startDate"} value={startDate_offtake} />

        <Typography variant="h6" color="text.primary_bold">
          Injection
        </Typography>
        <Divider />
        <InfoLine key={"companyName_injection"} name={"company"} value={companyName_injection} />
        <InfoLine key={"vatNumber_injection"} name={"vat n°"} value={vatNumber_injection} />
        <InfoLine key={"ean_injection"} name={"ean"} value={ean_injection} />
        <InfoLine key={"addressEan_injection"} name={"address"} value={addressEan_injection} />
        <InfoLine key={"startDate_injection"} name={"startDate"} value={startDate_injection} />
      </Stack>
    </CollapsableCard>
  );
}
